<template>
    <div class="slide-imagem">
        <div v-if="imagemDataUrl" class="slide-imagem-area">
            <img
                :src="imagemDataUrl"
                :alt="titulo || 'Imagem do slide'"
                class="slide-imagem-img"
                :class="`slide-imagem-img--${ajuste}`"
            />
        </div>
        <p v-else class="slide-vazio">Nenhuma imagem adicionada.</p>
        <p v-if="legenda" class="slide-imagem-legenda">{{ legenda }}</p>
    </div>
</template>

<script>
export default {
    name: 'SlideImagemApresentacao',

    props: {
        imagemDataUrl: {
            type: String,
            default: '',
        },
        legenda: {
            type: String,
            default: '',
        },
        titulo: {
            type: String,
            default: '',
        },
        ajuste: {
            type: String,
            default: 'contain',
        },
    },
}
</script>

<style scoped>
.slide-imagem {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.75rem;
    width: 100%;
    height: 100%;
    min-height: 0;
}

.slide-imagem-area {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 0;
    overflow: hidden;
}

.slide-imagem-img {
    max-width: 100%;
    max-height: 100%;
}

.slide-imagem-img--contain {
    object-fit: contain;
}

.slide-imagem-img--cover {
    object-fit: cover;
    width: 100%;
    height: 100%;
}

.slide-imagem-legenda {
    margin: 0;
    font-size: 0.9rem;
    color: #555;
    text-align: center;
    font-style: italic;
}

.slide-vazio {
    color: #666;
    font-style: italic;
}
</style>
